import React from 'react';
import { cn } from '../../lib/utils';

/**
 * KilometerCounter — compteur « kilométrique » roadbook.
 *
 * Remplace la « StatCardPerformance » sport. Utilise une typo monospace
 * pour donner la sensation d'un odomètre / compteur de moto.
 */
export const KilometerCounter = ({
  label,
  value,
  unit,
  hint,
  className,
  size = 'md',
  ...props
}) => {
  const sizeText = {
    sm: 'text-2xl',
    md: 'text-3xl sm:text-4xl',
    lg: 'text-5xl sm:text-6xl',
  }[size];

  return (
    <div
      className={cn('editorial-card p-4 sm:p-5 flex flex-col gap-1', className)}
      data-testid="km-counter"
      {...props}
    >
      <div className="editorial-kicker text-[10px]">{label}</div>
      <div className="flex items-baseline gap-1">
        <span
          className={cn('editorial-counter text-foreground leading-none tracking-tight', sizeText)}
          data-testid="km-counter-value"
        >
          {value}
        </span>
        {unit && (
          <span className="editorial-counter text-sm text-muted-foreground font-bold">{unit}</span>
        )}
      </div>
      {hint && (
        <div className="text-xs text-muted-foreground italic" style={{ fontFamily: "'Crimson Text', Georgia, serif" }}>
          {hint}
        </div>
      )}
    </div>
  );
};

export default KilometerCounter;
